<template>
	<div
		class="highlight-products"
		v-if="productsEnhanced.length && selectedProduct"
	>
		<div class="highlight-products__image">
			<figure class="highlight-products__image-wrapper">
				<img
					v-for="product in productsEnhanced"
					:key="`highlight-image-${product.code}`"
					class="highlight-products__image-element"
					:class="{
						'highlight-products__image-element--active': selectedProductCode == product.code
					}"
					:src="product.image"
					alt="Product Image"
				>
			</figure>
		</div>
		<div
			class="highlight-products__content"
			:class="[
				bgColorClass
			]"
		>
			<nav class="highlight-products__bullets">
				<button
					v-for="(product, index) in productsEnhanced"
					:key="`highlight-bullet-${product.code}`"
					class="highlight-products__bullet"
					:class="{
						'highlight-products__bullet--active': selectedProductCode == product.code,
						'highlight-products__bullet--pulsate': selectedProductCode == product.code && !clicked,
					}"
					type="button"
					@click.prevent="onBulletClick(product)"
				>
					<SVGDumpling class="highlight-products__bullet-icon"/>
				</button>
			</nav>
			<div class="highlight-products__details">
				<h3
					class="highlight-products__details-title"
					v-html="selectedProduct.name"
				/>
				<div
					class="highlight-products__details-description"
					v-html="selectedProduct.description || selectedProduct.shortDescription"
				/>
				<Button
					v-if="hasBasket && isAvailable && !selectedProduct.isEditable && !selectedProduct.isConfigurable"
					class="highlight-products__details-button"
					@click="onCart()"
					level="primary"
					type="button"
					:text="$t('shoplist.product.addToCart')"
					:disabled="locked"
					:variants="[
						'small'
					]"
				/>
				<Button
					v-else-if="!hasBasket"
					class="highlight-products__details-button"
					@click="goToShop()"
					level="primary"
					type="button"
					:text="$t('shoplist.product.toShop')"
					:variants="[
						'small'
					]"
				/>
				<div
					v-if="hasBasket && addedToCart"
					class="highlight-products__cart-notification"
					v-html="$t('shoplist.product.successCart')"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import GenericMixin from '@/mixins/GenericVueMixin'
import ProductListMixin from '@/mixins/ProductListVueMixin'
import Button from '@/components/Button';
import Loader from '@/components/Loader';

export default {
	mixins: [
		GenericMixin,
		ProductListMixin,
	],
	components: {
		Button,
		Loader,
	},
	data() {
		return {
			selectedProductCode: '',
			loading: false,
			addedToCart: false,
			quantity: 1,
			clicked: false,
		};
	},
	computed: {
		...mapGetters('productlist', [
			'highlightProducts',
		]),
		...mapGetters('cart', [
			'showContinue',
			'hasBasket',
		]),
		productsEnhanced() {
			return this.enhanceProducts(this.highlightProducts);
		},
		selectedProduct() {
			return this.productsEnhanced.find(p => p.code == this.selectedProductCode);
		},
		locked() {
			return this.lockedProducts[this.selectedProduct.code];
		},
		isAvailable() {
			return this.selectedProduct.variants[0].stock > 0;
		},
		bgColorClass() {
			return `madamesum--bg-${this.selectedProduct.bgColor || 'green'}`;
		},
	},
	methods: {
		onBulletClick(product) {
			this.addedToCart = false;
			this.selectedProductCode = product.code;
			this.clicked = true;
		},
		onCart() {
			this.addedToCart = false;

			if (this.selectedProduct.isEditable || this.selectedProduct.isConfigurable) {
				return;
			}

			const item = {
				quantity: this.quantity,
				productCode: this.selectedProduct.code,
				variantCode: this.selectedProduct.variants[0].code
			}

			this.onAddToCart(item);
			this.onAddedToCart();
		},
		onAddedToCart() {
			this.addedToCart = true;

			clearTimeout(this.messageTimeout);
			this.messageTimeout = setTimeout(() => {
				this.addedToCart = false;
			}, 3000);
		},
		goToShop() {
			this.$store.dispatch('redirect', {name: 'shop'})
		}
	},
	async created() {
		this.loading = true;
		try {
			await this.$store.dispatch('productlist/loadHighlightProducts');
			if (this.productsEnhanced.length) {
				this.selectedProductCode = this.productsEnhanced[0].code;
			}
		}
		catch {
			// do nothing
		}
		this.loading = false;
	}
}
</script>

<style>

</style>
